import { useQuery } from 'react-query';
import { useApp, useFields } from 'hooks';
import { add } from 'date-fns';
import { invoiceStatusFilter, invoiceTypeFilter } from 'constants/invoices';
import { getAllInvoices } from 'api';
import ListPlaceholder from 'components/ui-kit/list-placeholder';
import Filters from 'components/filters';
import InvoicesLoader from './loader';
import * as S from './styles';
import InvoiceItem from '../invoice-item';

const daterange = {
  from: add(new Date(), { days: -30 }),
  to: add(new Date(), { days: 7 }),
};

export default function InvoicesListing() {
  const { portal } = useApp();

  const { fields, handleClickChange, handleChange } = useFields({
    paymentStatus: 'all',
    invoiceType: 'all',
    daterange: [daterange.from, daterange.to],
  });

  const { data, isLoading, isFetching } = useQuery([
    'invoicesListingQuery',
    portal?.id,
    {
      from: fields.daterange[0].toISOString(),
      to: fields.daterange[1].toISOString(),
      invoiceStatus: invoiceStatusFilter[fields.paymentStatus],
      invoiceType: invoiceTypeFilter[fields.invoiceType],
    }], getAllInvoices, {
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!portal?.id,
  });

  const listingItems = data?.data || [];

  const renderContent = () => {
    if (isLoading || isFetching) {
      return <InvoicesLoader />;
    }

    if (!listingItems.length) {
      return <ListPlaceholder message="No invoices found" />;
    }

    return (
      <S.List>
        {listingItems.map((item) => (
          <S.ListItem key={`${item.invoiceType}-${item.id}`}>
            <InvoiceItem
              id={item.id}
              portalId={portal?.id}
              title={item.name}
              sentDate={item.sentDate}
              paidDate={item.paidDate}
              totalAmount={item.totalAmount}
              taxAmount={item.taxAmount}
              amountDue={item.amountDue}
              creditToBeApplied={item.creditToBeApplied}
              invoiceType={item.invoiceType}
              invoiceSettingsOverride={item.invoiceSettingsOverride}
            />
          </S.ListItem>
        ))}
      </S.List>
    );
  };

  return (
    <>
      <Filters
        fields={fields}
        handleClickChange={handleClickChange}
        handleChange={handleChange}
        select={{
          options: [
            { label: 'All', value: 'all' },
            { label: 'Due', value: 'due' },
            { label: 'Paid', value: 'paid' },
          ],
          name: 'paymentStatus',
          label: 'Payment Statuses',
        }}
        secondSelect={{
          options: [
            { label: 'All Types', value: 'all' },
            { label: 'Job', value: 'job' },
            { label: 'Service Plan', value: 'service-plan' },
          ],
          name: 'invoiceType',
          label: 'Invoice Type',
        }}
      />
      {renderContent()}
    </>
  );
}
